module.exports = __webpack_public_path__ + "img/cloth_g1_item_03.cfa906e1.svg";